import { RequestService } from '@app/shared/utils/request-service/request-service';
import { privateAdapter } from '@app/shared/utils/request-service/adapters/private-adapter';

export class AxiosRequestService {
  privateRequest: RequestService = new RequestService(privateAdapter);
  publicRequest: RequestService = new RequestService(privateAdapter);
}
